import type { FunctionComponent, PropsWithChildren } from 'react';
import { createContext, useRef } from 'react';
import type { StoreApi } from 'zustand';

import type { SkillActionStore } from './skill-action-store';
import { createSkillActionStore } from './skill-action-store';

export const SkillActionStoreContext = createContext<StoreApi<SkillActionStore> | null>(null);

type SkillActionSwitcherProviderProps = {
    readonly initialStore?: StoreApi<SkillActionStore>;
};

export const SkillActionSwitcherProvider: FunctionComponent<PropsWithChildren<SkillActionSwitcherProviderProps>> = ({
    children,
    initialStore,
}) => {
    const storeRef = useRef<StoreApi<SkillActionStore>>(initialStore ?? createSkillActionStore());

    return <SkillActionStoreContext.Provider value={storeRef.current}>{children}</SkillActionStoreContext.Provider>;
};
